var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#2DCE89"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9877 25.7945L45.7037 18.7949C45.6243 18.5534 45.4696 18.3452 45.2634 18.2019C45.0572 18.0587 44.8108 17.9883 44.5617 18.0016H19.4383C19.1892 17.9883 18.9428 18.0587 18.7366 18.2019C18.5304 18.3452 18.3757 18.5534 18.2963 18.7949L16.0123 25.7945C15.9959 25.9183 15.9959 26.0439 16.0123 26.1678V33.1674C16.0123 33.4768 16.1327 33.7735 16.3468 33.9923C16.561 34.2111 16.8514 34.334 17.1543 34.334H18.2963V46H20.5802V34.334H27.4321V46H45.7037V34.334H46.8457C47.1486 34.334 47.439 34.2111 47.6532 33.9923C47.8673 33.7735 47.9877 33.4768 47.9877 33.1674V26.1678C48.0041 26.0439 48.0041 25.9183 47.9877 25.7945ZM43.4198 43.6668H29.716V34.334H43.4198V43.6668ZM45.7037 32.0008H41.1358V27.3344H38.8519V32.0008H33.142V27.3344H30.858V32.0008H25.1481V27.3344H22.8642V32.0008H18.2963V26.3544L20.2605 20.3348H43.7395L45.7037 26.3544V32.0008Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d6a6ce29.svg";
export { ForwardRef as ReactComponent };